// Flat Ocean with no shadow: the Arches frame shows one solid fill and a clean
// edge, and the palette's approved pairing for this banner is Ivory on Ocean.
export const finalSettlementHeaderClasses =
    'flex justify-between items-center px-6! py-4! bg-primary';

export const finalSettlementTitleClasses =
    'text-white! text-2xl font-semibold leading-9 tracking-[calc(var(--spacing)*0.075)] m-0! mb-1!';

export const finalSettlementSubtitleClasses =
    'text-white text-xs font-normal leading-[calc(var(--spacing)*4.5)] mb-0!';

const FinalSettlementBaseHeader = ({
    rightContent = null,
    className = '',
    showSettleAllView
}) => {
    const radiusClass = showSettleAllView ? 'rounded-t' : 'rounded';

    return (
        <div className={`${finalSettlementHeaderClasses} ${radiusClass} ${className}`}>
            <div>
                <h3 className={finalSettlementTitleClasses}>
                    Final Settlement
                </h3>
                <p className={finalSettlementSubtitleClasses}>
                    Enter the settlement amounts to obtain settlement analytical data
                </p>
            </div>

            {rightContent && (
                <div className="flex gap-2">
                    {rightContent}
                </div>
            )}
        </div>
    );
};

export default FinalSettlementBaseHeader;
